/* eslint-disable */
import axios from 'axios';

export default {
    state : {
        quality : [],
    },

    methods : {

    },

    getters : {

        getAllQuality(state) {

            return state.quality;

        },

        getQualityByDirection: state => d => {
            return state.quality.filter(item => item.directions.indexOf(d) > -1);
        },

        getQualityById: state => id => {
            return state.quality.find(item => item.id == id);
        },


    },

    mutations: {

        setQuality(state, quality) {
            state.quality = quality;
        }
    
    },

    actions : {

        getQuality({dispatch, commit}) {

            return new Promise((resolve, reject) => {
                    axios.get('/quality')
                    .then(response => {
                        commit('setQuality', response.data);
                        resolve(response.data);
                    })
                    .catch(error => {
                        if ((error.response.status == 401)||(error.response.status == 500)) {
                            console.log(error);
                        }
                        else {
                            let t = error.response.status == 429 ? 15000 : 1500;
                            if (error.response.headers["retry-after"] != undefined) t = error.response.headers["retry-after"];
                            setTimeout(()=>{ // повторная загрузка
                                dispatch('getQuality')
                            }, t);
                        }
                        reject(error.response.status);
                    });
            });
        },

    }

}